<div class='container'>
      <div class="pt-4">
          <a href="http://www.bankersfidelity.com" target="_blank">
              <img src="../assets/images/logo.png" />
          </a>
          <hr />
      </div>
  <router-outlet></router-outlet>
</div>
